 export const calculatePageCount = (dataLength: number): number => {
    if (dataLength < 5) {
      return 1
    } else {
      return Math.ceil(dataLength /5)
    }
  }


  export const statusBgColor = (status: string): string => {
    switch (status) {
      case 'active':
        return 'lightGreen'
      case 'archived':
        return 'paleYellow'
      case 'suspended':
        return 'palePink'
      default:
        return 'gray3'
    }
  }

  interface Item {
    value: string
    label: string
  }
  export function findLabelByValue(
    valueToFind: string,
    arrayOfObjects: Item[]
  ): string | null {
    // Loop through the array
    for (let i = 0; i < arrayOfObjects.length; i++) {
      // Check if the current object's value matches the value to find
      if (arrayOfObjects[i].value === valueToFind) {
        // Return the label of the matching object
        return arrayOfObjects[i].label
      }
    }
    // If no match is found, return null or handle appropriately
    return null
  }